module.exports = __webpack_public_path__ + "img/Wp_2061.a9e3867c.png";